import ApiService from '@/services/api.service'

export default {
  index: () =>
    ApiService().get('/user/project-stages'),

  store: (name: string) =>
    ApiService().post('/user/project-stages', { name }),

  update: (id: number, name: string) =>
    ApiService().patch(`/user/project-stages/${id}`, { name }),

  destroy: (id: number) =>
    ApiService().delete(`/user/project-stages/${id}`),
}
